'use strict';

(function () {
  'use strict';

  angular.module('msOnboarding').controller('SsoPasswordCtrl', SsoPasswordCtrl);

  SsoPasswordCtrl.$inject = ['$stateParams', '$log', '$scope', '$sessionStorage', 'onboardingRouter', 'authenticationSvc', 'userSvc', 'providerSvc', 'organization'];

  function SsoPasswordCtrl($stateParams, $log, $scope, $sessionStorage, onboardingRouter, authenticationSvc, userSvc, providerSvc, organization) {
    var vm = this;
    var ssoAuthView = $sessionStorage.ssoAuthView;
    vm.invalid = false;
    vm.submit = _submit;
    vm.goToNextStep = _goToNextStep;
    vm.firstName = '';
    vm.emailAddress = '';
    vm.password = '';
    vm.isPasswordCreated = false;

    _init();

    function _init() {
      // Catch error from resolved organization
      if (organization.errorCode || !ssoAuthView || !ssoAuthView.attributesView) {
        onboardingRouter.navigateSsoError({
          contact: true
        });
        return;
      }

      // Set firstName
      vm.firstName = ssoAuthView.attributesView.firstName ? ssoAuthView.attributesView.firstName : '';
      vm.emailAddress = ssoAuthView.attributesView.emailAddress ? ssoAuthView.attributesView.emailAddress : '';

      providerSvc.setProvider({
        accessCode: ssoAuthView.attributesView.accessCode,
        organization: organization.shortName
      });

      vm.cobrandingText = organization.name;
      providerSvc.getHeader().then(function (data) {
        var contentItem = null;
        if (data && data.content) {
          contentItem = data.content.filter(function (headerContent) {
            return headerContent.target === 'image';
          })[0];
          if (contentItem) {
            vm.cobranding = contentItem.replacement;
          }
        }
      });
    }

    function _onError(data) {
      if (data && data.hasOwnProperty('message')) {
        if (_.includes(data.message, 'password')) {
          $scope.form.password.$setValidity('duplicate', false);
          $scope.form.processing = false;
        } else {
          onboardingRouter.navigateError({
            message: data.message,
            contact: true
          });
        }
      } else {
        // got no message back
        $log.debug(data);
        onboardingRouter.navigateError({
          message: 'A networking error occurred'
        });
      }
    }

    function _onSuccess() {
      $scope.form.processing = false;
      //no longer do we go to resume.  Instead we fulfill requirements
      if (ssoAuthView.attributesView.redirectUrl) {
        $sessionStorage.redirectUrl = ssoAuthView.attributesView.redirectUrl;
      }
      vm.isPasswordCreated = true;
    }

    function _submit() {
      if (!$scope.form.$valid) {
        $scope.form.password.$setDirty();
        return;
      }
      $scope.form.processing = true;
      vm.invalid = false;

      // Do ssoLogin then save the users password
      authenticationSvc.ssoLogin(ssoAuthView).then(function (resp) {
        userSvc.saveUser({
          id: resp.data.response.id,
          password: vm.password
        }, _onSuccess, _onError, true);
      }, onboardingRouter.ssoMapLoginError);
    }

    function _goToNextStep() {
      onboardingRouter.goToNextStep();
    }
  }
})();